// extracted by mini-css-extract-plugin
module.exports = {"icon":"j_8sT8lq"};